import { Project } from '../types';

export const projects: Project[] = [
  {
    id: 1,
    title: 'Contemporary Apartment Makeover',
    description: 'A complete redesign of a 2-bedroom apartment with a focus on maximizing space and incorporating natural light.',
    image: 'https://images.pexels.com/photos/1571458/pexels-photo-1571458.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1'
  },
  {
    id: 2,
    title: 'Traditional Family Home',
    description: 'Bringing warmth and character to a suburban family home with classic design elements and modern comfort.',
    image: 'https://images.pexels.com/photos/1571463/pexels-photo-1571463.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1'
  },
  {
    id: 3,
    title: 'Minimalist Studio Redesign',
    description: 'Transforming a small studio into a functional and aesthetically pleasing space with clever storage solutions.',
    image: 'https://images.pexels.com/photos/3797991/pexels-photo-3797991.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1'
  },
  {
    id: 4,
    title: 'Luxury Penthouse Design',
    description: 'Creating an elegant and sophisticated atmosphere in a high-rise penthouse with panoramic city views.',
    image: 'https://images.pexels.com/photos/1571457/pexels-photo-1571457.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1'
  }
];